import script from "./changeSkin.vue?vue&type=script&lang=ts&setup=true"
export * from "./changeSkin.vue?vue&type=script&lang=ts&setup=true"

import "./changeSkin.vue?vue&type=style&index=0&id=686cdeb9&scoped=true&lang=css"

import exportComponent from "E:\\vs\\integrate-system\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-686cdeb9"]])

export default __exports__